import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import "./Onboarding.css";

// Header Components
export const HeaderContainer = styled(Box)(({ theme }) => ({
  height: "50px",
  background: "#FFFFFF 0% 0% no-repeat",
  border: "2px solid #F2F2F4",
  textAlign: "center",
}));

export const Logo = styled(Box)(({ theme }) => ({
  paddingTop: "10px",
}));

// Heading Components
export const Heading = styled(Box)(({ theme }) => ({
  fontSize: "40px",
  lineHeight: "55px",
  fontWeight: 600,
  marginTop: "11%",
  fontFamily: "Sora",
}));

export const SupplierPortalHeading = styled(Box)(({ theme }) => ({
  fontSize: "40px",
  lineHeight: "55px",
  fontWeight: 600,
  marginTop: "11%",
  fontFamily: "Sora",
}));

// Menu Components
export const MenuContainer = styled(Box)(({ theme }) => ({
  marginLeft: "4%",
  flexDirection: "column",
  paddingTop: "3%",
  justifyContent: "space-between",
}));

export const SelectedMenu = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  width: "90%",
  padding: "8px",
  borderRadius: "8px",
  boxShadow: "0px 3px 32px #00000014",
  border: "2px solid #E5E5E9",
  display: "flex",
  marginTop: "10%",
  cursor: "pointer",
}));

export const KavidaImg = styled('img')(({ theme }) => ({
  marginTop: "6px",
  height: "18px",
}));

export const SelectedMenuText = styled(Box)(({ theme }) => ({
  color: "#6361EE",
  fontWeight: 600,
  fontSize: "14px",
  fontFamily: "Sora",
  padding: "7px",
}));

export const MenuText = styled(Box)(({ theme }) => ({
  color: "#7F7D94",
  fontWeight: 600,
  fontSize: "14px",
  fontFamily: "Sora",
  padding: "7px",
}));

export const Menu = styled(Box)(({ theme }) => ({
  background: "#FAFAFA",
  boxShadow: "inset 0px 3px 8px #00000008, 0px 3px 24px #00000000",
  border: "2px solid #E5E5E9",
  borderRadius: "8px",
  width: "90%",
  padding: "8px",
  display: "flex",
  marginTop: "10%",
  cursor: "pointer",
}));

// Description Components
export const DescriptionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "1%",
  marginLeft: "7%",
  width: "44%",
}));

export const ContentDescription = styled(Box)(({ theme }) => ({
  color: "#7F7D94",
  fontSize: "19px",
  marginTop: "8%",
  fontFamily: "Figtree",
  lineHeight: 1.5,
}));

export const SupplierContentDescription = styled(Box)(({ theme }) => ({
  color: "#7F7D94",
  fontSize: "19px",
  marginTop: "8%",
  fontFamily: "Figtree",
  lineHeight: 1.5,
}));

// Button Components
export const ViewNextBtn = styled(Button)(({ theme }) => ({
  background: "transparent linear-gradient(314deg, #9F88FF 0%, #1999A3 100%)",
  borderRadius: "8px",
  color: "#fff",
  fontSize: "14px",
  textTransform: "none",
}));

export const PlatformBtn = styled(Button)(({ theme }) => ({
  background: "transparent linear-gradient(314deg, #9F88FF 0%, #1999A3 100%)",
  borderRadius: "8px",
  color: "#fff",
  width: "51%",
  marginTop: "9%",
  fontSize: "14px",
  textTransform: "none",
}));

export const LeftArrow = styled('img')(({ theme }) => ({
  height: "16px",
  paddingLeft: "5px",
}));

// Purchase Order Components
export const PurchaseOrderContainer = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  width: "120%",
  padding: "10px",
  borderRadius: "8px",
  boxShadow: "0px 3px 32px #00000014",
  marginTop: "10%",
  marginRight: "3%",
  height: "27%",
}));

export const PurchaseOrderText = styled(Box)(({ theme }) => ({
  fontWeight: 600,
}));

// Status Container Components
export const RequireContainer = styled(Box)(({ theme }) => ({
  background: "#ffefef",
  padding: "10px",
  height: "auto",
}));

export const RequireText = styled(Box)(({ theme }) => ({
  color: "#ff3e3e",
  fontWeight: 600,
}));

export const AwaitingContainer = styled(Box)(({ theme }) => ({
  background: "#fffaeb",
  padding: "10px",
  height: "auto",
}));

export const AwaitingText = styled(Box)(({ theme }) => ({
  color: "#dcb638",
  fontWeight: 600,
}));

export const OnTrackContainer = styled(Box)(({ theme }) => ({
  background: "#edf7f8",
  padding: "10px",
  height: "auto",
  width: "27%",
}));

export const OnTrackText = styled(Box)(({ theme }) => ({
  color: "#259ea8",
  fontWeight: 600,
}));

// Skip Components
export const SkipText = styled(Box)(({ theme }) => ({
  color: "#6361EE",
  marginTop: "2%",
  marginLeft: "4%",
  cursor: "pointer",
  fontFamily: "Figtree",
  fontSize: "14px",
}));

export const SkipBtnContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  marginTop: "12%",
}));

// Backward compatibility - export individual styles as a styles object
const styles = () => ({
  headerContainer: {},
  logo: {},
  heading: {},
  supplierPortalHeading: {},
  menuContainer: {},
  selectedMenu: {},
  kavidaImg: {},
  selectedMenuText: {},
  menuText: {},
  menu: {},
  descriptionContainer: {},
  contentDescription: {},
  supplierContentDescription: {},
  viewNextBtn: {},
  platformbtn: {},
  leftArrow: {},
  PurchaseOrderContainer: {},
  purchaseOrderText: {},
  requireContainer: {},
  requireText: {},
  awaitingContainer: {},
  awaitingText: {},
  onTrackContainer: {},
  onTrackText: {},
  skipText: {},
  skipbtnContainer: {},
});

export default styles;
